import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Field } from 'redux-form';

import Menu from 'components/common/Menu';
import Grid from '@material-ui/core/Grid';

import TextField from 'components/fields/TextField';
import IconButton from 'components/common/IconButton';
import IconMoney from 'components/icons/IconMoney';
import IconUndo from 'components/icons/IconUndo';

import sortInsurance from 'utils/sortInsurance';
import formatPrice from 'utils/formatPrice';

import OrdersTableRowItemRecoupForm from './OrdersTableRowItemRecoupForm';

const styles = theme => ({ 
  containerCheckNumber: {
    '& + $containerCheckNumber': {
      marginTop: 8,
    },
  },
  inputAdornment: {
    marginRight: 0,
  },
  iconButton: {
    margin: '-10px -10px -10px -2px',
  },
  iconRecoup: {
    position: 'relative',
    width: 24,
    height: 24,
  },
  iconRebill: {
    position: 'relative',
    width: 24,
    height: 24,
  },
  iconRedo: {
    position: 'absolute',
    right: 2,
    top: -7,
    width: 20,
    height: 20,
    color: theme.palette.add[500],
    transform: 'scaleX(-1)',
  },
  iconMoney: {
    position: 'relative',
    top: 1,
    width: 24,
    height: 24,
  },
  iconUndo: {
    position: 'absolute',
    right: 4,
    top: -7,
    width: 20,
    height: 20,
    color: theme.palette.validation[500],
  },
  gridItemShrink: {
    flexShrink: 1,
  },
});

class OrdersTableRowItemCheckNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusValue: null,
      anchorEl: null,
      variant: 'recoup',
      activeInsuranceID: null,
    };

    this.onFieldFocus = this.onFieldFocus.bind(this);
    this.onRecoupButtonClick = this.onRecoupButtonClick.bind(this);
    this.onRebillButtonClick = this.onRebillButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onMenuExited = this.onMenuExited.bind(this);
    this.onSubmitRecoupFormSuccess = this.onSubmitRecoupFormSuccess.bind(this);
  }

  onFieldFocus(event) {
    this.setState({
      focusValue: {
        [event.target.name]: event.target.value,
      },
    });
  }

  onRecoupButtonClick(event, insuranceID) {
    this.setState({
      anchorEl: event.currentTarget,
      variant: 'recoup',
      activeInsuranceID: insuranceID,
    });
  }

  onRebillButtonClick(event, insuranceID) {
    this.setState({
      anchorEl: event.currentTarget,
      variant: 'rebill',
      activeInsuranceID: insuranceID,
    });
  }

  onMenuClose() {
    this.setState({
      anchorEl: null,
      activeInsuranceID: null,
    });
  }

  onMenuExited() {
    
  }

  onSubmitRecoupFormSuccess(res) {
    this.setState({
      anchorEl: null,
    });
  }

  render() {
    const {
      namePrefix,
      onBlur,
      disabled,
      Insurance,
      classes,
      className,
      orderLineID,
      orderID,
      orderLineInsuranceParam,
    } = this.props;
    const { focusValue, anchorEl, variant, activeInsuranceID } = this.state;
    if (!Insurance || Insurance.length === 0) {
      return '';
    }
    return (
      <div>
        {sortInsurance(Insurance).map(insurance => {
          const open = Boolean(anchorEl) && activeInsuranceID === insurance.ID;
          const currentOrderLineInsuranceParam = orderLineInsuranceParam.filter(item =>
            item.Insurance.ID === insurance.ID);
          const lastOrderLineInsuranceParam = currentOrderLineInsuranceParam[currentOrderLineInsuranceParam.length - 1];
          let isRecoupActive;
          let isRebillActive;
          if (lastOrderLineInsuranceParam && lastOrderLineInsuranceParam.Reimbs
            && Number(lastOrderLineInsuranceParam.Reimbs) > 0) {
            isRecoupActive = true;
          }
          if (lastOrderLineInsuranceParam && lastOrderLineInsuranceParam.Reimbs
            && Number(lastOrderLineInsuranceParam.Reimbs) < 0) {
            isRebillActive = true;
          }
          return (
            <Grid className={classes.containerCheckNumber} container spacing={0} wrap="nowrap">
              <Grid className={classes.gridItemShrink} item>
                <Field
                  key={insurance.ID}
                  className={className}
                  id={`${namePrefix}.Check Book Sheet.insuranceID-${insurance.ID}.Check Number`}
                  name={`${namePrefix}.Check Book Sheet.insuranceID-${insurance.ID}.Check Number`}
                  component={TextField}
                  disabled={disabled}
                  onFocus={this.onFieldFocus}
                  onBlur={(event, newValue) => {
                    if (focusValue
                      && focusValue[`${namePrefix}.Check Book Sheet.insuranceID-${insurance.ID}.Check Number`] !== undefined
                      && focusValue[`${namePrefix}.Check Book Sheet.insuranceID-${insurance.ID}.Check Number`] !== newValue) {
                      const values = {
                        [namePrefix]: {
                          'Check Book Sheet': {},
                        },
                      };
                      values[namePrefix]['Check Book Sheet'][`insuranceID-${insurance.ID}`] = {
                        'Check Number': newValue,
                      };
                      onBlur(values);
                    }
                    this.setState({ focusValue: null });
                  }}
                  size="sm"
                  color="light"
                  errorPlacement="left"
                  fullWidth
                />
              </Grid>
              {(insurance['Insurance Type'] !== 'Self' && (isRecoupActive || isRebillActive)) && (
                <Grid item>
                  {isRecoupActive && (
                    <IconButton
                      tooltipContent="Recoup"
                      tooltipPlacement="top"
                      className={classes.iconButton}
                      onClick={event => this.onRecoupButtonClick(event, insurance.ID)}
                    >
                      <div className={classes.iconRecoup}>
                        <IconMoney
                          className={classes.iconMoney}
                        />
                        <IconUndo className={classes.iconUndo} />
                      </div>
                    </IconButton>
                  )}
                  {isRebillActive && (
                    <IconButton
                      tooltipContent="Rebill"
                      tooltipPlacement="top"
                      className={classes.iconButton}
                      onClick={event => this.onRebillButtonClick(event, insurance.ID)}
                    >
                      <div className={classes.iconRebill}>
                        <IconMoney
                          className={classes.iconMoney}
                        />
                        <IconUndo className={classes.iconRedo} />
                      </div>
                    </IconButton>
                  )}
                  <Menu
                    id="orders-recoup-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={this.onMenuClose}
                    onExited={this.onMenuExited}
                    placement="top-right"
                    maxHeight={244}
                    list={false}
                  >
                    <OrdersTableRowItemRecoupForm
                      form={`${namePrefix}-${insurance.ID}-recoupForm`}
                      insurance={insurance}
                      variant={variant}
                      orderLineID={orderLineID}
                      orderID={orderID}
                      onSubmitSuccess={this.onSubmitRecoupFormSuccess}
                      onCancel={this.onMenuClose}
                      {...isRecoupActive ? {
                        initialValues: {
                          Recoup: formatPrice(-lastOrderLineInsuranceParam.Reimbs),
                        },
                      } : {}}
                    />
                  </Menu>
                </Grid>
              )}
            </Grid>
          );
        })}
      </div>
    );
  }
}

OrdersTableRowItemCheckNumber.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  Insurance: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
};

OrdersTableRowItemCheckNumber.defaultProps = {
  className: '',
  onBlur: () => {},
  Insurance: [],
  disabled: false,
};

export default withStyles(styles)(OrdersTableRowItemCheckNumber);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemCheckNumber.js